<template>
  <div class="addvip">
   <div class="content">
      <!-- 标题 -->
    <div class="title">
      <i class="el-icon-edit"></i>
      <span>修改会员信息</span>

      <!-- 返回按钮 -->
      <div class="back">
        <el-button round size='mini' class="back-btn" icon='el-icon-arrow-left' @click="back">返回</el-button>
      </div>
    </div>
    

    <!-- 表单内容 -->
    <el-form :model="form" class="main" size="medium" status-icon label-width="120px" ref="ruleForm">

      <el-form-item label="上传头像:" prop="link">
          <el-upload
            name="file"
            class="avatar-uploader"
            action=''
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :http-request="uploadFile"
          >

             <img v-if="this.form.img" :src="this.$store.state.ip+this.form.img" class="avatar"
             :rules="{ required: true, message: '请上传相片', trigger: ['click','submitForm']}"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      <el-form-item label="姓名:" prop="name"
      :rules="{ required: true, message: '姓名不能为空', trigger: ['blur','change']}">
        <el-input v-model="form.name" placeholder="请输入姓名" autocomplete="off"></el-input>
      </el-form-item>
       <el-form-item label="证件号码:" prop="tel"  >
        <el-input v-model="form.tel" disabled></el-input>
      </el-form-item>
      <el-form-item label="会员号" prop="info" >
        <el-input v-model="form.info" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="所属单位" prop="group" >
        <el-input v-model="form.group" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="所属地市" prop="district" >
        <el-input v-model="form.district" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="性别:" prop="sex" :rules="{ required: true, message: '性别不能为空', trigger: ['blur','change']}">
        <el-radio-group v-model="form.sex">
          <el-radio label="男"></el-radio>
          <el-radio label="女"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="出生年月:" prop="birth" :rules="{ required: true, message: '出生年月不能为空', trigger: ['blur','change']}">
        <el-date-picker type="date" value-format="yyyy-MM-dd" class="time-input" placeholder="选择日期" v-model="form.birth"></el-date-picker>
      </el-form-item>
      <el-form-item label="手机号:" prop="price"  >
        <el-input v-model="form.price" placeholder="请输入手机号" 
        :rules="[tel,{ trigger: ['blur','change']}]"></el-input>
      </el-form-item>
      <el-form-item class="control">
        <el-button type="danger" icon="el-icon-close" @click="back">取消</el-button>
        <el-button @click="resetForm('ruleForm')" class="reset-btn" icon="el-icon-refresh-left">重置</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" icon="el-icon-document-add">保存</el-button>
      </el-form-item>
    </el-form>
   </div>
  </div>
</template>
<script>
 export default {
     data() {
      // var checkPhone = (rule, value, callback) => {
      //   if (!value) {
      //     return callback(new Error('证件号不能为空'));
      //   } else {
      //     //const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      //     const reg =/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      //     if (reg.test(value)) {
      //       callback();
      //     } else {
      //       return callback(new Error('请输入正确的证件号'));
      //     }
      //   }
      // };
      var checkTel = (rule, value, callback) => {
        if (value){
          const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
          //const reg =/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的证件号'));
          }
        }
      };
      return {
        file:{},
        form: {
          id:'',
          img:'',
          tel:'',
          name:'',
          sex:'',
          time:"",
          birth:'',
          info:'',
          operater:''
        },
        //phone:{validator: checkPhone, trigger: ['blur','change']},
        tel:{validator: checkTel, trigger: ['blur','change']},
        data:[]
      }
    },
    methods: {
      //返回房产信息列表
      back(){
        this.$router.push({path:'/home/teacher'});
      },

      // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
      handleChange(file) {
        this.file = file.raw
        console.log(this.file);
      },

      // 上传文件之前的钩子
      beforeUpload(file) {
        console.log("上传前");
        const isJPG = file.type === "image/jpeg"||"image/png";
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error("上传头像图片只能是 JPG或png 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
      },

      // 自定义图片上传
      uploadFile() {
        // 创建表单对象
        let form = new FormData();
        // 后端接受参数 ，可以接受多个参数
        form.append("file",this.file)

        // 请求头设置文件上传
        let config = {
            //必须
          headers: {
              "Content-Type": "multipart/form-data"
          },
        }
        // 发送请求
        this.axios.post('/teacher/upload',form,config)
        .then(res=>{
          console.log(res.data)
          if(res.data.code=='200'){
            this.form.img = res.data.url;
          }
        })
        .catch(err=>{
          console.log(err)
        })
      },

      // 格式化时间
      switchTimeFormat(time) {
        const dateTime = new Date(time);
        const year = dateTime.getFullYear();
        const month = dateTime.getMonth() + 1;
        const date = dateTime.getDate();
        return `${year}-${this.PrefixInteger(month,2)}-${this.PrefixInteger(date,2)}`;
      },


      //格式化数字
      PrefixInteger(num, n) {
        return (Array(n).join(0) + num).slice(-n);
      },

      // 格式化数据
      formateData(item){
        var data={};
       // data.id=item.t_id;
        //data.uid=item.u_id;
        //data.no=this.PrefixInteger(item.t_id,10);

        // data.img = item.t_img?item.t_img:'/img/avator.jpg';
        // data.name = item.t_name;
        // data.price = item.t_price;
        // data.tel = item.u_tel;
        // data.birth = item.t_birth?this.switchTimeFormat(item.t_birth):'';
        // data.sex = item.t_sex?'女':'男';
        // data.info = item.t_info?item.t_info:"";
        // this.value = item.t_rate;
        // if(item.v_state){
        //   data.time = this.switchTimeFormat(item.v_startTime)+' 至 '+this.switchTimeFormat(item.v_endTime)
        // }
        // console.log(data);
        data.district=item.m_district
        data.group=item.m_group
        data.tel=item.m_idNum
        data.name=item.m_name
        data.sex=item.m_sex
        data.birth=this.switchTimeFormat(item.m_birth)
        data.info=item.m_num
        data.img=item.m_img
        data.price=item.m_tel
        data.operater=item.operater
    
        return data;
      },


      // 提交表单
      submitForm(formName) {
        this.form.operater=sessionStorage.getItem("tel");
        
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$confirm("此操作会将数据永久性修改，确认是否继续操作?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(()=>{
              console.log("seccess!",this.form);
              this.axios.post('/users/findTel',{
                tel:this.form.tel
                //role:2,
                //id:this.form.uid
              })
              .then(res=> {
                console.log(res.data);
                if(res.data.code == 0){
                  this.$message.error(res.data.msg);
                }
                else{
                  
                  this.axios.post("/teacher/alter",{
                  district:this.form.district,
                  group:this.form.group,
                  tel:this.form.tel,
                  name:this.form.name,
                  sex:this.form.sex,
                  birth:this.form.birth,
                  info:this.form.info,
                  img:this.form.img,
                  price:this.form.price,
                  operater:this.form.operater,
                  id:this.id
                  })
                  .then(res=>{
                    console.log(res);
                    if(res.data.code=='200'){
                      this.$message.success(res.data.msg);
                      this.$router.push({path:'/home/teacher'});
                    }
                  })
                  .catch(err=>{
                    console.log(err);
                  })
                }
              })
              .catch(err=>{
                console.log(err)
              })
              
            })
            .catch(()=>{
              this.$message.info("已取消修改");
            })
            
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      },

      // 重置表单
      resetForm() {
        this.form=this.formateData(this.data);
      },

    },
    mounted() {//创建时获取数据
    this.id=this.$route.params.id
    console.log(this.id);
    this.axios.post("/teacher/getInfo", {
      id:this.$route.params.id
    })
    .then((res) => {
      console.log(res);
      if(res.data.code=='200'){
        this.loading=false;
        //res.data.data.m_birth=this.switchTimeFormat(res.data.data.m_birth);
        this.data = res.data.data     
        this.form=this.formateData(this.data);
      }
    })
    .catch(err=> {
      console.log(err)
    })
  },
  }
</script>
<style lang="less">
@import "../assets/less/base.less";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: @greenColor;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<style lang="less" scoped>
@import "../assets/less/base.less";
.addvip {
  color: @fontColor;
  background-color: white;
  min-height: 500px;
}
.content {
  background: white;
}
.title {
  padding: 15px 20px;
  border-top: 3px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
  i {
    margin-right: 2px;
  }
  .back {
    float: right;
    .back-btn{
      padding: 5px;
    }
  }
}
.main{
  padding: 20px;
}
.el-input--medium,.el-select,.time-input{
  width: 300px;
}
.reset-btn{
  background: @blueGreenColor;
  color: white;
  border-color: @blueGreenColor;
}
.el-form--inline .control{
  text-align: right;
  width: 100%;
}
</style>